/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/productDetail.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { toast } from "react-hot-toast";

const log: any = LoggerModule?.getInstance();

export interface IGetProductDetailMethods extends IPluginMethodMap {
  getProductDetail(args: any, apiURL: string): Promise<any>;
}

export interface getProductDetailProps {
  apiURL?: string;
}

export class GetProductDetailService implements IAgentPlugin {
  readonly methods?: IGetProductDetailMethods;

  constructor() {
    this.methods = {
      getProductDetail: this.getProductDetail.bind(this),
    };
  }

  private _getGtin() {
    const urlParams = new URLSearchParams(window.location.search);
    let id = urlParams.get("gtin");
    if (id) {
      id = String(id).trim();
    }
    return id;
  }

  private _getImages(images: any[]) {
    let _res: any[] = [];
    images &&
      Array.isArray(images) &&
      images.length > 0 &&
      images.map((item: any, index: number) => {
        if (item) {
          _res.push({
            original: item?.src,
            thumbnail: item?.src,
          });
        }
      });
    console.log(` images :`, _res);

    return _res;
  }

  private _getOrganizationInfo(data: any) {
    let _socialLink: any = [];
    data &&
    data?.socialLinks &&
    Array.isArray(data?.socialLinks) &&
    data?.socialLinks.length > 0
      && data?.socialLinks.map((item: any, index: number) => {
          if (item?.type !== "email" && item?.type !== "phone")
            _socialLink.push({
              ...item,
              type: `social-${item?.type}`,
            });
        })

    return {
      ...data,
      socialLinks: _socialLink,
    };
  }

  async getProductDetail(args: getProductDetailProps) {
    let _gtin = this._getGtin();
    console.log(`args in full provenance service :`, args, _gtin);
    try {
      const res = await axios.post(
        `${args.apiURL}${config?.productDetailEP}`,
        {
          gtin: _gtin,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      if (res?.data) {
        let _data = res?.data?.data?.productDetails;
        console.log(`on Success :`, _data);

        return {
          ..._data,
          images: this._getImages(_data?.ProductImages?.productImages),
          productTitleCard: _data?.ProductTitleCard,
          productDetailInfo: _data?.ProductDetailInfo,
          organizationInfo: this._getOrganizationInfo(_data?.OrganizationInfo),
        };
      }
      //}
    } catch (err: any) {
      console.log(`on error :`, err);
      toast.error(`${err?.response?.data?.error_message}`);
      // return err;
    }
  }
}
